// totalStep="1" (질문 1개)- 1.이름&번호
// totalStep="2" (질문 2개)- 1.임플란트 갯수, 2.이름&번호
// numberColor - #0854fc(밝은 파란색),#0824a4(남색), #3f8c58(짙은 녹색),#18646c(청록색)
// qOptionColor - blue, green, teal

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import { validateName, validatePhoneNumber } from "../utils/validation";
import {
  options,
  options3,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import SelectCountry from "../components/SelectCountry";
import PrivacyContent from "./PrivacyContent";

function RandingStyle20({
  urlCode,
  urlCodeSettingId,
  totalStep,
  img1Path,
  img2Path,
  img3Path,
  formFieldColor,
  postBTN,
  companyName,
  footerPath,
  randingNumber,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  privacyMessage,
  kakaotalk,
  carrotTag,
  allCountry, //전지점
}) {
  const navigate = useNavigate();

  // 상태 관리.
  const [selectedValue, setSelectedValue] = useState(null); // 선택된 값을 저장할 상태

  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });

  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option, group) => {
    setSelectedOption((prev) => {
      const optionsArray = prev ? prev.split(",") : ["", ""]; // 위쪽과 아래쪽 옵션을 각각 관리
      if (group === "top") {
        // 위쪽 옵션 선택
        optionsArray[0] = option; // 첫 번째 그룹에 선택된 옵션 저장
      } else if (group === "bottom") {
        // 아래쪽 옵션 선택
        optionsArray[1] = option; // 두 번째 그룹에 선택된 옵션 저장
      }
      return optionsArray.join(","); // 콤마로 연결된 문자열 반환
    });
    console.log("Selected options:", selectedOption);
  };

  const nextStep = () => {
    if (currentStep < totalStep) {
      setCurrentStep(currentStep + 1); // 다음 단계로 이동
    } else {
      handleSubmit(); // 마지막 단계에서는 폼 제출
    }
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    if (allCountry && (!selectedOption || selectedOption.trim() === "")) {
      alert("가까운 지역을 선택해주세요."); // 사용자에게 알림
      return;
    }
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      // 이벤트 복수 세팅
      selectedValue,
      kakaotalk,
      carrotTag,
    });
  };
  console.log(currentStep);

  const audioRef = useRef(null);

  const handlePlayAudio = () => {
    const audio = audioRef.current;
    if (audio && currentStep === 1) {
      audio.currentTime = 0; // ✅ 0초로 설정 (처음부터 재생)
      audio.muted = false;
      audio.volume = 1;
      audio.play().catch((err) => {
        console.warn("재생 실패:", err);
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      handlePlayAudio();
      window.removeEventListener("scroll", handleScroll);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentStep]);

  return (
    <div className="form-container" onClick={handlePlayAudio}>
      <audio
        ref={audioRef}
        autoPlay
        muted
        loop={false}
        src={`${process.env.REACT_APP_CDN_BASE}/images/${randingNumber}/audio${randingNumber}-${currentStep}.mp3`}
        style={{ display: "none" }}
      />

      {currentStep === 1 && (
        <div className="step1" style={{ position: "relative" }}>
          <img src={img1Path} onClick={nextStep} alt="임플란트 고민중이세요?" />
        </div>
      )}

      {currentStep === 2 && (
        <div className="step1" style={{ position: "relative" }}>
          <img src={img2Path} alt="임플란트 고민중이세요?" />
          <div
            style={{
              position: "absolute",
              bottom: window.innerWidth > 768 ? "5%" : "40px", // PC는 상대값, 모바일은 고정값
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              // gap: "4vw",
              gap: window.innerWidth > 768 ? "2vw" : "30px", // PC는 상대값, 모바일은 고정값
            }}
          >
            {[1, 2, 3].map((num) => (
              <img
                key={num}
                src={`${process.env.REACT_APP_CDN_BASE}/images/qOptions/btn/ai/${num}.png`}
                alt={`AI 버튼 ${num}`}
                onClick={nextStep}
                style={{
                  width: "80%",
                }}
              />
            ))}
          </div>
        </div>
      )}

      {currentStep === 3 && (
        <div className="step2" style={{ position: "relative" }}>
          <img src={img3Path} alt="임플란트 고민중이세요?" />
          <div
            className="qBox"
            style={{
              position: "absolute",
              bottom: window.innerWidth > 768 ? "5%" : "10px", // PC는 상대값, 모바일은 고정값
            }}
          >
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            <form
              className="formBox"
              onSubmit={(e) => {
                e.preventDefault(); // 기본 제출 동작 방지
                handleSubmit(); // 기존 handleSubmit 호출
              }}
            >
              <div
                className={`formField ${
                  formFieldColor === "white" ? "white" : ""
                }`}
              >
                <label htmlFor="name">이름</label>
                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="이름을 입력해주세요."
                />
              </div>
              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
                formFieldColor={formFieldColor}
              />
              <p
                className="benefitInfo"
                style={
                  window.innerWidth > 768
                    ? { paddingTop: 25, paddingBottom: 10 }
                    : {}
                }
              >
                <BenefitPeriod />
                <br />
                이벤트 대상자 : 해당 매체 이용자
              </p>
              <PrivacyPolicyAgree
                isAgreed={isAgreed}
                setIsAgreed={setIsAgreed}
                togglePrivacyPolicyModal={togglePrivacyPolicyModal}
                privacyMessage={privacyMessage}
                styleOptions={true}
              />

              <button
                type="submit"
                className="sendBtnBox"
                disabled={isSubmitting}
              >
                <img src={postBTN} alt="신청하기" />
              </button>
            </form>
          </div>
        </div>
      )}
      {isPrivacyPolicyModal && (
        <div
          className="modalOverlay"
          onClick={togglePrivacyPolicyModal}
          style={{
            width: "100%",
            backgroundColor: "#d8e3ff",
            margin: "0",
          }}
        >
          <div
            className="privacyPolicyContent"
            style={{
              fontSize: "clamp(12px, 2vw, 16px)",
              padding: "5vw",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <PrivacyContent companyName={companyName} />
          </div>
        </div>
      )}
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle20;
